/* jshint esversion: 6 */
/* jshint ignore:start */
import axios from 'axios';
import { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import { useNavigate } from 'react-router-dom';
import { showToast } from '../../showTost';
import emptyimg from "../../assets/Image/emptyOrder.png";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
import { LuCalendar, LuChevronRight } from 'react-icons/lu';
import { IoChevronBackOutline, IoCloseSharp, IoCloseCircle } from 'react-icons/io5';

const MyOrder = () => {

  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [currentOrder, setCurrentOrder] = useState([]);
  const [pastOrder, setPastOrder] = useState([]);
  const [cancelReasonList, setCancelReasonList] = useState([]);
  const [isCancelBox, setIsCancelBox] = useState("");
  const [selectReason, setSelectReason] = useState();
  const [otherReason, setOtherReason] = useState();
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totallength, setTotalLength] = useState(0);

  const [selectBtn, setSelectBtn] = useState(0);
  const Navigate = useNavigate();
  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);


  const Userid = secureLocalStorage.getItem("Userid");
  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";

  useEffect(() => {
    HandleFetchCurrentOrderData(1);
    axios.get(`${ApiBaseUrl}/customer/appint_cancel_list`)
      .then((res) => {
        // console.log("appint_cancel_list", res);
        setCancelReasonList(res.data.cancel_reason);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const HandleFetchCurrentOrderData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/medi_pending_order_list`, { uid: Userid, page })
        .then((res) => {
          // console.log("medi_pending_order_list", res.data);
          const { ResponseCode, running } = res.data;
          if (ResponseCode === 200) {
            if (page === 1) {
              setCurrentOrder(running);
              setTotalLength(running.length);
              if (running.length === 0) NoMoreDataRef.current = false;
            } else {
              if (running.length === 0 || totallength > running.length) NoMoreDataRef.current = false;
              setCurrentOrder(prev => [...prev, ...running]);
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleFetchPastOrderData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/medi_complete_order_list`, { uid: Userid, page })
        .then((res) => {
          // console.log("medi_complete_order_list", res.data);
          const { ResponseCode, complete } = res.data;
          if (ResponseCode === 200) {
            if (page === 1) {
              setPastOrder(complete);
              setTotalLength(complete.length);
              if (complete.length === 0) NoMoreDataRef.current = false;
            } else {
              if (complete.length === 0 || totallength > complete.length) NoMoreDataRef.current = false;
              setPastOrder(prev => [...prev, ...complete]);
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;

      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

      if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
        hasReachedBottom.current = true;
        setPage(prev => prev + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };

  }, []);

  useEffect(() => {

    if (page === 1 || !NoMoreDataRef.current) return;

    if (selectBtn === 0) {
      HandleFetchCurrentOrderData(page);
    } else {
      HandleFetchPastOrderData(page);
    }
  }, [page, selectBtn])

  const HandleGetInfo = (id, index) => {
    Navigate("/order-details", { state: { id, index } });
  };

  const HandleCancelAppointment = () => {

    if (!selectReason) {
      showToast({ title: t("Select Cancel Reason"), id: "error" });
      return;
    }

    if (selectReason === 4 && !otherReason) {
      showToast({ title: t("Enter Other Reason"), id: "error" });
      return;
    }

    if (Userid) {

      const Data = {
        order_id: String(isCancelBox),
        cancel_id: selectReason,
        reason: otherReason ? otherReason : ""
      };

      axios.post(`${ApiBaseUrl}/customer/product_order_cancel`, Data)
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            showToast({ title: res.data.message, id: "success" });
            setIsCancelBox("");
            setPage(1);
            NoMoreDataRef.current = true;
            HandleFetchCurrentOrderData(1);
          }

        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleSelectBtn = (index) => {
    setSelectBtn(index);
    setPage(1);
    NoMoreDataRef.current = true;
    if (index === 0) {
      HandleFetchCurrentOrderData(1);
    } else {
      HandleFetchPastOrderData(1);
    }
  }

  return (
    <div className="my-order-container w-full min-h-screen pb-[100px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" index={0} />
      ) : (
        <div className="flex flex-col">
          {/* Header Navigation / Breadcrumbs */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
            <button 
              onClick={() => window.history.back()} 
              className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
            >
              <IoChevronBackOutline className="w-4 h-4" />
              <span className="font-medium text-sm">{t("Go Back")}</span>
            </button>
            
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <span className="hover:text-indigo-650 font-medium transition-colors cursor-pointer" onClick={() => Navigate("/dashbord")}>{t("Dashboard")}</span>
              <LuChevronRight className="w-3.5 h-3.5" />
              <span className="font-semibold text-slate-800">{t("My Orders")}</span>
            </div>
          </div>

          {/* Premium Tab Selector */}
          <div className="flex justify-center mb-8">
            <div className="bg-slate-100 p-1.5 rounded-full flex gap-2 shadow-sm border border-slate-150">
              <button 
                onClick={() => HandleSelectBtn(0)} 
                className={`px-6 py-2.5 rounded-full text-xs font-black tracking-wider uppercase transition-all duration-200 ${
                  selectBtn === 0 
                    ? "bg-white text-indigo-600" 
                    : "text-slate-500 hover:text-slate-700 animate-fade-in"
                }`}
              >
                {t("Current Order")}
              </button>
              <button 
                onClick={() => HandleSelectBtn(1)} 
                className={`px-6 py-2.5 rounded-full text-xs font-black tracking-wider uppercase transition-all duration-200 ${
                  selectBtn === 1 
                    ? "bg-white text-indigo-600" 
                    : "text-slate-500 hover:text-slate-700 animate-fade-in"
                }`}
              >
                {t("Past Order")}
              </button>
            </div>
          </div>

          {/* Grid Layout for Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {selectBtn === 0 ? (
              currentOrder.length >= 1 ? (
                currentOrder.map((item, index) => (
                  <div 
                    key={index} 
                    onClick={() => HandleGetInfo(item.id, 0)} 
                    className="bg-white rounded-3xl border border-slate-150 overflow-hidden shadow-sm hover:shadow-md hover:border-indigo-100 transition-all duration-300 cursor-pointer flex flex-col group"
                  >
                    {/* Card Banner Cover */}
                    <div className="relative h-48 bg-slate-50 overflow-hidden">
                      <ImageLoad 
                        src={ImgBaseUrl + item.image} 
                        CustomeStyle="w-full h-full object-cover transition-transform duration-500 group-hover:scale-103" 
                        alt="order product" 
                      />
                      <div className="absolute top-3 left-3 bg-indigo-50 border border-indigo-100 text-indigo-700 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow-sm">
                        {t("Current")}
                      </div>
                      <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm border border-slate-155 text-slate-700 text-[10px] font-mono font-bold px-2.5 py-1 rounded-full shadow-sm">
                        #{item.id}
                      </div>
                    </div>

                    {/* Card Info Details */}
                    <div className="p-5 flex flex-col flex-1 justify-between gap-4">
                      <div className="flex flex-col gap-1.5">
                        <div className="flex items-center justify-between text-xs text-slate-400 font-semibold uppercase tracking-wider">
                          <span>{t("Products")}: {item.tot_product}</span>
                          <span className="flex items-center gap-1">
                            <LuCalendar className="w-3.5 h-3.5" />
                            {item.date}
                          </span>
                        </div>
                        <h3 className="font-bold text-slate-800 text-base line-clamp-1 group-hover:text-indigo-650 transition-colors">
                          {item.name}
                        </h3>
                      </div>

                      <div className="flex items-center justify-between border-t border-slate-100 pt-4 mt-auto">
                        <div className="flex flex-col">
                          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{t("Total Price")}</span>
                          <span className="font-black text-indigo-600 text-lg">{currency}{item.tot_price}.00</span>
                        </div>
                        
                        <div className="flex items-center gap-2 shrink-0">
                          <button 
                            onClick={(e) => { e.stopPropagation(); setIsCancelBox(item.id); }} 
                            className="px-4 py-2 border border-rose-200 hover:border-rose-300 bg-rose-50/50 hover:bg-rose-100 text-rose-600 font-bold text-xs rounded-full transition-all duration-200 active:scale-95"
                          >
                            {t("Cancel")}
                          </button>
                          <button 
                            onClick={() => HandleGetInfo(item.id, 0)} 
                            className="px-4 py-2 border border-indigo-200 hover:border-indigo-300 bg-indigo-50/50 hover:bg-indigo-100 text-indigo-650 font-bold text-xs rounded-full transition-all duration-200 active:scale-95"
                          >
                            {t("Info")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-span-full py-16 flex flex-col items-center justify-center text-center">
                  <div className="w-24 h-24 bg-slate-50 border border-slate-150 rounded-full flex items-center justify-center mb-4 shadow-inner">
                    <img src={emptyimg} className="w-16 h-16 object-contain opacity-75" alt="no order" />
                  </div>
                  <h3 className="font-bold text-slate-800 text-lg mb-1">{t("No Order placed !!")}</h3>
                  <p className="text-slate-400 text-sm max-w-xs">{t("Currently You Don't Have Any Booking")}</p>
                </div>
              )
            ) : (
              pastOrder.length >= 1 ? (
                pastOrder.map((item, index) => (
                  <div 
                    key={index} 
                    onClick={() => HandleGetInfo(item.id, 1)} 
                    className="bg-white rounded-3xl border border-slate-150 overflow-hidden shadow-sm hover:shadow-md hover:border-indigo-100 transition-all duration-300 cursor-pointer flex flex-col group"
                  >
                    {/* Card Banner Cover */}
                    <div className="relative h-48 bg-slate-50 overflow-hidden">
                      <ImageLoad 
                        src={ImgBaseUrl + item.image} 
                        CustomeStyle="w-full h-full object-cover transition-transform duration-500 group-hover:scale-103" 
                        alt="order product" 
                      />
                      
                      {/* Past Status Indicator */}
                      <div className="absolute top-3 left-3">
                        {item.status === "3" ? (
                          <div className="bg-emerald-50 border border-emerald-100 text-emerald-700 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow-sm flex items-center gap-1">
                            <RiVerifiedBadgeFill className="w-3.5 h-3.5 text-emerald-500" />
                            <span>{t("Completed")}</span>
                          </div>
                        ) : (
                          <div className="bg-rose-50 border border-rose-100 text-rose-700 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow-sm flex items-center gap-1">
                            <IoCloseCircle className="w-3.5 h-3.5 text-rose-500" />
                            <span>{t("Cancelled")}</span>
                          </div>
                        )}
                      </div>

                      <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm border border-slate-155 text-slate-700 text-[10px] font-mono font-bold px-2.5 py-1 rounded-full shadow-sm">
                        #{item.id}
                      </div>
                    </div>

                    {/* Card Info Details */}
                    <div className="p-5 flex flex-col flex-1 justify-between gap-4">
                      <div className="flex flex-col gap-1.5">
                        <div className="flex items-center justify-between text-xs text-slate-400 font-semibold uppercase tracking-wider">
                          <span>{t("Products")}: {item.tot_product}</span>
                          <span className="flex items-center gap-1">
                            <LuCalendar className="w-3.5 h-3.5" />
                            {item.date}
                          </span>
                        </div>
                        <h3 className="font-bold text-slate-800 text-base line-clamp-1 group-hover:text-indigo-650 transition-colors">
                          {item.name}
                        </h3>
                      </div>

                      <div className="flex items-center justify-between border-t border-slate-100 pt-4 mt-auto">
                        <div className="flex flex-col">
                          <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{t("Total Price")}</span>
                          <span className="font-black text-indigo-600 text-lg">{currency}{item.tot_price}.00</span>
                        </div>
                        
                        <button 
                          onClick={() => HandleGetInfo(item.id, 1)} 
                          className="px-4 py-2 border border-indigo-200 hover:border-indigo-300 bg-indigo-50/50 hover:bg-indigo-100 text-indigo-650 font-bold text-xs rounded-full transition-all duration-200 active:scale-95 shrink-0"
                        >
                          {t("Info")}
                        </button>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-span-full py-16 flex flex-col items-center justify-center text-center">
                  <div className="w-24 h-24 bg-slate-50 border border-slate-150 rounded-full flex items-center justify-center mb-4 shadow-inner">
                    <img src={emptyimg} className="w-16 h-16 object-contain opacity-75" alt="no order" />
                  </div>
                  <h3 className="font-bold text-slate-800 text-lg mb-1">{t("No Order placed !!")}</h3>
                  <p className="text-slate-400 text-sm max-w-xs">{t("Currently You Don't Have Any Booking")}</p>
                </div>
              )
            )}
          </div>
        </div>
      )}

      {/* Cancellation Centered Modal */}
      {isCancelBox && (
        <div 
          onClick={() => setIsCancelBox("")} 
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div 
            onClick={(e) => e.stopPropagation()} 
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[80vh] scroll-container relative flex flex-col gap-5"
          >
            <button 
              onClick={() => setIsCancelBox("")} 
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-655 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>
            
            <div>
              <h2 className="font-bold text-slate-800 text-lg leading-snug">{t("Cancel Order")}</h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">{t("Please Select the Reason for Cancellation")}</p>
            </div>

            <div className="flex flex-col gap-3 mt-1">
              {cancelReasonList.map((item, index) => (
                <label 
                  onClick={() => setSelectReason(item.id)} 
                  key={index} 
                  className={`flex items-center gap-3 p-3.5 border rounded-2xl cursor-pointer transition-all duration-150 ${
                    selectReason === item.id 
                      ? "border-indigo-600 bg-indigo-50/30 text-indigo-900 font-bold" 
                      : "border-slate-200 hover:border-slate-300 text-slate-700 font-medium"
                  }`}
                >
                  <div className="w-[20px] check-box flex items-center justify-center shrink-0">
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center border transition-colors ${
                      selectReason === item.id ? "border-indigo-600 bg-indigo-600" : "border-slate-300"
                    }`}>
                      <span className={`w-2 h-2 rounded-full bg-white duration-150 ${selectReason === item.id ? "scale-100" : "scale-0"}`}></span>
                    </div>
                  </div>
                  <span className="text-sm leading-tight">{item.title}</span>
                </label>
              ))}
              
              {selectReason === 4 && (
                <input 
                  type="text" 
                  onChange={(e) => setOtherReason(e.target.value)} 
                  className="border border-slate-200 focus-within:outline-none focus:border-indigo-650 focus:ring-1 focus:ring-indigo-650 w-full py-3 px-4 rounded-2xl text-sm mt-1 shadow-sm" 
                  placeholder={t('Enter other reason details')} 
                />
              )}
            </div>

            <div className="grid grid-cols-2 gap-4 mt-2">
              <button 
                onClick={() => setIsCancelBox("")} 
                className="py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-2xl text-sm transition-all duration-150 active:scale-98"
              >
                {t("Close")}
              </button>
              <button 
                onClick={HandleCancelAppointment} 
                className="py-3 bg-rose-600 hover:bg-rose-700 text-white font-bold rounded-2xl text-sm transition-all duration-150 active:scale-98 shadow-md shadow-rose-600/10"
              >
                {t("Confirm")}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MyOrder;
/* jshint ignore:end */